import { useContext } from "react";
import { CreateNFeContext } from "../../../../../Context";

export function userNFePayment() {
  const NFeContext = useContext(CreateNFeContext);
  const setNFePayment = (payment) => {
    const { nfe } = NFeContext;
    const { updateNFeData, updateTotalNFe } = NFeContext.handlers;
    nfe.payments.push(payment);
    nfe.total_paid = nfe.payments.reduce((acc, cur) => acc + cur.value, 0);
    const left =
      nfe.total_nfe - (nfe.total_paid + nfe.identification.discount_value);
    nfe.paid_value = left < 0 ? 0 : left;
    updateNFeData(nfe);
    updateTotalNFe();
  };
  return setNFePayment;
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFePaymentShipping/Payments/components/AddPayment/hooks/index.js